import { useState, useEffect, useRef } from "react";
import { Row, Col, FormControl } from "react-bootstrap";
import UiButton from "../../components/button";
import Loader from "../../components/loader";
import Web3 from "web3";
import {
  PrimaryIssueManager,
  SecuritiesFactory,
  contractAddress,
} from "@verified-network/verified-sdk";

import DateTimePicker from "react-datetime-picker";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import {
  SuccessToast,
  FailureToast,
  ToastOptions,
  countryDetails,
  getCountryName,
  networks,
} from "../../utils/constants";
import { toast } from "react-toastify";
import { shortAddress } from "../../components/common/CommonHeader";
import "react-toastify/dist/ReactToastify.css";
import {
  useNetworkOptions,
  useIntermediaryList,
} from "../../context/contractDataLoaderService";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../utils/helpers/networks";
import { providers } from "ethers";
import { useGlobal } from "../../context/globalContext";
import { getAllVerifiedCashBalances } from "../../utils/helpers";

function StartIssueModal(props) {
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    verifiedWalletDetails,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;

  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [custodian, setCustodian] = useState(null);
  const [value, onChange] = useState(new Date());
  const [country, setCountry] = useState("");
  const [changeContent, setChangeContent] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const modalContent = useRef(null);
  const { data: networkOptions } = useNetworkOptions("issue");
  const { data: custodianList } = useIntermediaryList(country, "Custodian");

  let primaryIssueManagerContract, securitiesfactory;
  if (provider && provider.getSigner && chainId && address) {
    const BalancerPrimaryIssueManager =
      contractAddress[chainId].BalancerPrimaryIssueManager;
    if (BalancerPrimaryIssueManager) {
      primaryIssueManagerContract = new PrimaryIssueManager(
        signer,
        BalancerPrimaryIssueManager,
        "balancer",
      );
    }
    if (contractAddress[chainId].SecuritiesFactory) {
      securitiesfactory = new SecuritiesFactory(
        signer,
        contractAddress[chainId].SecuritiesFactory,
      );
    }
  }
  const filteredCountries = countryDetails.filter((country) =>
    country.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );
  const startIssue = async () => {
    let dateTime = Math.floor(value.getTime() / 1000).toString();
    dateTime = web3.utils.toWei(dateTime, "ether");
    setLoading(true);
    if (
      props?.data?.issueManager?.toLowerCase() === account.toLowerCase() &&
      custodian
    ) {
      try {
        let paymentToken;

        if (
          verifiedWalletDetails &&
          Object?.keys(verifiedWalletDetails)?.length > 0
        ) {
          const cashTokens = await getAllVerifiedCashBalances(
            chainId,
            web3,
            account,
          );

          if (!cashTokens || cashTokens?.length === 0) {
            setLoading(false);
            toast.error(
              "No valid Cash Token on this network. Change network and try again.",
              ToastOptions,
            );

            return;
          }
          paymentToken = cashTokens[0];
          const txQuote = await securitiesfactory._getMeeQuote(
            cashTokens[0]?.address,
            "setCustodian",
            [props.data.offered, props.data.owner, custodian],
          );

          if (
            Number(cashTokens[0]?.balance) === 0 ||
            Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
          ) {
            setLoading(false);
            toast.error(
              `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
              ToastOptions,
            );

            return;
          }
        }

        await securitiesfactory
          .setCustodian(
            props.data.offered,
            props.data.owner,
            custodian,
            paymentToken?.address
              ? {
                  paymentToken: paymentToken?.address,
                  apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                }
              : {},
          )
          .then((res) => {
            if (res?.status === 0) {
              toast.success("Transaction Successful", ToastOptions);
            } else {
              setLoading(false);
              toast.error("Transaction Failed.", ToastOptions);
              return;
            }
          });
      } catch (err) {
        let error = { err };
        console.log(error);
        const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${error.err?.transactionHash}`;
        setLoading(false);
        toast.error(FailureToast(transactionLink), ToastOptions);
        return;
      }
    }
    setLoading(true);
    try {
      let paymentToken;

      if (
        verifiedWalletDetails &&
        Object?.keys(verifiedWalletDetails)?.length > 0
      ) {
        const cashTokens = await getAllVerifiedCashBalances(
          chainId,
          web3,
          account,
        );

        if (!cashTokens || cashTokens?.length === 0) {
          setLoading(false);
          toast.error(
            "No valid Cash Token on this network. Change network and try again.",
            ToastOptions,
          );

          return;
        }
        paymentToken = cashTokens[0];
        const txQuote = await primaryIssueManagerContract._getMeeQuote(
          cashTokens[0]?.address,
          "issue",
          [props.data.offered, dateTime, props.data.owner],
        );

        if (
          Number(cashTokens[0]?.balance) === 0 ||
          Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
        ) {
          setLoading(false);
          toast.error(
            `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
            ToastOptions,
          );

          return;
        }
      }

      await primaryIssueManagerContract
        .issue(
          props.data.offered,
          dateTime,
          props.data.owner,
          paymentToken?.address
            ? {
                paymentToken: paymentToken?.address,
                apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
              }
            : {},
        )
        .then((res) => {
          setLoading(false);
          if (res?.status === 0) {
            const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${res?.response?.hash}`;
            toast.success(SuccessToast(transactionLink), ToastOptions);
            setChangeContent(true);
            modalContent.current.innerHTML = "";
          } else {
            toast.error("Transaction Failed", ToastOptions);
          }
        });
    } catch (err) {
      let error = { err };
      console.log(error);
      const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${error.err?.transactionHash}`;
      setLoading(false);
      toast.error(FailureToast(transactionLink), ToastOptions);
    }
  };
  return (
    <>
      {loading ? <Loader /> : null}
      {changeContent && (
        <UiButton
          onClick={() => {
            props.onModalHide();
          }}
          buttonVariant="primary"
          buttonClass="SignUpButton flex-1 ml-0"
          buttonText="Click to close this form&nbsp;&rarr;"
          type="submit"
        />
      )}
      <div className="d-grid gap-2" ref={modalContent}>
        <Row className="ml-1 align-items-center">
          {props?.data?.issueManager?.toLowerCase() ===
            account?.toLowerCase() && (
            <>
              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col xs={{ span: 3, offset: 2 }} className="text-left">
                  <b>Country</b>
                </Col>
                <Col className="pl-0" xs={5}>
                  <DropdownButton
                    id="dropdown-basic-button"
                    title={
                      country
                        ? getCountryName(country, "fullList")
                        : "Select country"
                    }
                  >
                    <FormControl
                      type="text"
                      placeholder="Search country"
                      className="mx-3 my-2 w-auto"
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    {filteredCountries.map((country) => (
                      <Dropdown.Item
                        key={country.code}
                        onClick={() => setCountry(country.code)}
                      >
                        {country.name}
                      </Dropdown.Item>
                    ))}
                  </DropdownButton>
                </Col>
              </Row>
              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col xs={{ span: 3, offset: 2 }} className="text-left">
                  <b>Custodian</b>
                </Col>
                <Col className="pl-0" xs={5}>
                  <DropdownButton
                    id="dropdown-basic-button"
                    title={
                      custodianList
                        ? custodianList.length
                          ? custodian
                            ? shortAddress(custodian)
                            : "Select custodian"
                          : "Select custodian"
                        : null
                    }
                  >
                    {custodianList ? (
                      custodianList.length ? (
                        custodianList?.map((manager) => (
                          <Dropdown.Item
                            key={manager.address}
                            onClick={(e) => setCustodian(manager.address)}
                          >
                            <b>{manager.name}</b>&nbsp;(
                            {shortAddress(manager.address)})
                          </Dropdown.Item>
                        ))
                      ) : (
                        <span className="p-2">
                          {country
                            ? "No custodian present"
                            : "Select a country"}
                        </span>
                      )
                    ) : null}
                  </DropdownButton>
                </Col>
              </Row>
            </>
          )}

          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Cutoff time</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <DateTimePicker onChange={onChange} value={value} />
            </Col>
          </Row>
          <Row className="mx-0 my-2 pl-0 width-100 align-items-center">
            <Col className="pl-0">
              <UiButton
                onClick={() => {
                  if (web3 && signer && chainId && account) {
                    startIssue();
                  }
                }}
                buttonVariant="primary"
                buttonClass="SignUpButton flex-1 ml-0"
                buttonText="Start"
                type="submit"
              />
            </Col>
          </Row>
        </Row>
      </div>
    </>
  );
}

export function StartIssue(props) {
  return <StartIssueModal {...props} />;
}
